<div class="loading">
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
  {{ "page.link.loading" | translate }}
</div>
